import {Component, ViewChild} from '@angular/core';
import {Events, IonicPage, LoadingController, NavController, NavParams, Content, AlertController} from 'ionic-angular';
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {InsuranceProvider} from "../../providers/insurance/insurance";
import {IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiProvider} from "../../providers/api/api";
import {AppModuleDetailsPage} from "../app-module-details/app-module-details";
import {AppPaymentPage} from "../app-payment/app-payment";
import {AppYubleCodePopupPage} from "../app-yuble-code-popup/app-yuble-code-popup";

/**
 * Generated class for the IntroInsuranceConfirmationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intro-insurance-confirmation',
  templateUrl: 'intro-insurance-confirmation.html',
})
export class IntroInsuranceConfirmationPage {
  selectedCompanyObject;
  response: number = 0;
  @ViewChild(Content) public content: Content;

  constructor(public navCtrl: NavController, public navParams: NavParams, public contentTranslation: ContentTranslationProvider, public insurance: InsuranceProvider, public introWizard: IntroWizardServiceProvider, public userState: UserStateProvider, public api: ApiProvider, public events: Events, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    console.log(this.introWizard);
    this.insurance.getCompanies().then(data => {
      for(var company of data) {
        if(company.name == this.introWizard.insurer) {
          this.selectedCompanyObject = company;
        }
      }
      if(!this.selectedCompanyObject) {
        this.navCtrl.pop();
      }
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IntroInsuranceConfirmationPage', this.content);
  }

  evaluationInfoClick(e) {
    if(e.target.tagName == 'STRONG' && e.target.className.indexOf('modal-evaluation-info')>-1) {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Evaluation info modal title'),
        subTitle: this.contentTranslation.translateContent('Evaluation info modal body'),
        buttons: [
          {
            text: 'OK',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }

        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();
    }
  }

  goNext() {
    if(this.introWizard.freeOffer) {
      if(this.response == 1) {
        this.api.callPost('/users/' + this.userState.user.id + "/evaluation", {}).subscribe(() => {
          console.log('evaluation mail sent');
        });
      }

      this.events.publish('state:refresh');
      this.navCtrl.popToRoot().then(item => {
        this.navCtrl.push(AppYubleCodePopupPage, {paymentProcess: 1});
      });
      return ;
    }

    var loader = this.loadingCtrl.create();
    loader.present();
    let insuranceData = this.introWizard.insurance;
    insuranceData.type = this.introWizard.insurer;

    if(!this.introWizard.freeOffer) {
      insuranceData.nonAokId = insuranceData.aokId;
      insuranceData.aokId = '';
    }

    this.api.callPut('/users/'+this.userState.user.id, {insurance: insuranceData}).subscribe((res:any) => {
      loader.dismissAll();

      this.userState.user.insurance = {
        type: insuranceData.type,
        firstName: insuranceData.firstName,
        lastName: insuranceData.lastName,
        aokId: insuranceData.aokId,
        birthDate: insuranceData.birthDate
      };

      this.navCtrl.popToRoot().then(() => {
        this.navCtrl.push(AppPaymentPage);
      });
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/intro-insurance-confirmation/intro-insurance-confirmation.ts